import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { CartContextProvider } from '@fff-web/fff-cart';

import useCartData from 'pages/MyAccount/hooks/useCartData';
import { receiveUpdateCart as receiveUpdateCartAction } from 'pages/MyAccount/services/actions/cartActions';
import { receiveCartProducts as receiveCartProductsAction } from 'pages/MyAccount/services/actions/productsActions';
import { VERSION } from 'pages/MyAccount/utils/campaign';

const CartContext = ({
  version,
  cartDetails,
  account,
  products,
  variants,
  children,
  receiveUpdateCart,
  receiveCartProducts,
}) => {
  const { prevPurchasedVariantQuantities, customizeCampaignDetails } = cartDetails;
  const cartData = useCartData(
    cartDetails,
    products,
    variants,
    prevPurchasedVariantQuantities,
    customizeCampaignDetails,
  );
  const isEditPage = version === VERSION.edit;
  const isSalePage = version === VERSION['add-ons'] || isEditPage || version === VERSION.shop;

  return (
    <CartContextProvider
      cartData={cartData}
      account={account}
      receiveUpdateCart={isSalePage && receiveUpdateCart}
      receiveCartProducts={isSalePage && receiveCartProducts}
    >
      {children}
    </CartContextProvider>
  );
};

const mapStateToProps = (state) => ({
  cartDetails: state.cartState,
  account: state.userState,
  products: state.productsState.products,
  variants: state.productsState.variants,
});

const mapDispatchToProps = {
  receiveUpdateCart: receiveUpdateCartAction,
  receiveCartProducts: receiveCartProductsAction,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(CartContext);
